import React, { type FC, useMemo } from 'react';
import clsx from 'clsx';
import { isNil, negate } from 'lodash-es';
import { FlexBox } from '@is24at/react-ui-core';
import { RegularBadgeLabel } from '@is24at/react-enums';
import { BADGEType, ShownOn } from '@is24at/schemas/types';
import { type BadgeRegular, type TypedBadge } from 'server/types/graphql';
import Badge from '../Badge';
import styles from './BadgeList.scss';

interface BadgeListProps {
  typedBadges: TypedBadge[];
}

const filterRenderableBadges = (badges: TypedBadge[]) =>
  badges
    .filter(
      (badge): badge is BadgeRegular =>
        badge.type === BADGEType.Regular &&
        badge.shownOn.includes(ShownOn.Resultlist),
    )
    .map((badge) => ({
      label: RegularBadgeLabel[badge.details.value],
      augmentation: badge.augmentation,
    }))
    .filter(({ label }) => negate(isNil)(label));

const BadgeList: FC<BadgeListProps> = ({ typedBadges }) => {
  const renderableBadges = useMemo(
    () => filterRenderableBadges(typedBadges),
    [typedBadges],
  );

  return (
    <FlexBox
      tag="section"
      spacing={0}
      alignItems="start"
      wrap
      className={clsx(styles['badge-list'], 'pt-16', 'pb-12')}
    >
      {renderableBadges.map((badge) => (
        <Badge key={badge.label} {...badge} />
      ))}
    </FlexBox>
  );
};

export default BadgeList;
